import 'css-chunksrc/client/common/pagedResources/styles.scss';export default {
  "pagedResources": "_pagedResources_1e1wy_1",
  "grownContent": "_grownContent_1e1wy_6",
  "loader": "_loader_1e1wy_11"
};